module.exports = __webpack_public_path__ + "img/cat-empty-ocio.4134c035.svg";